import * as React from "react";
import "VSS/LoaderPlugins/Css!Agile/Scripts/BacklogsHub/Planning/Components/PlanningRow";
import { BacklogIterationCard } from "Agile/Scripts/BacklogsHub/Planning/Components/BacklogIterationCard";
import { DragDropScopes } from "Agile/Scripts/Common/Agile";
import { IIterationCardProps, IterationCard } from "Agile/Scripts/Common/Components/IterationCard/IterationCard";
import { MoveToIterationHelper } from "Agile/Scripts/Common/Utils";
import { Iteration } from "Agile/Scripts/Models/Iteration";
import { SimpleDropZone } from "Presentation/Scripts/TFS/Components/SimpleDropZone";
import { BacklogConfigurationService } from "Presentation/Scripts/TFS/FeatureRef/BacklogConfiguration/Service";
import { IWorkItemDragInfo } from "Agile/Scripts/Common/IWorkItemDragInfo";
import { Team } from "Agile/Scripts/Models/Team";
import { format } from "VSS/Utils/String";
import * as BacklogContentViewResources from "Agile/Scripts/Resources/TFS.Resources.BacklogsHub.BacklogView";

export interface IPlanningRowProps extends IIterationCardProps {
    /** Is this iteration the backlog iteration */
    isBacklogIteration?: boolean;
    /** The URL to show as the href on the backlog row header link */
    backlogUrl?: string;
    /** Get the current work items that are being dragged */
    getWorkItemDragInfo: ($item: JQuery) => IWorkItemDragInfo;
    /** Handler for when work items are dropped on this row */
    onWorkItemsDropped?: (workItemIds: number[], iterationPath: string, iterationName: string, $item: JQuery) => void;
    /** Callback invoked when the backlog row is clicked */
    onBacklogClicked?: (event: React.MouseEvent<HTMLElement>) => void;
    /** On Iteration clicked */
    onIterationClicked?: (event: React.MouseEvent<HTMLElement>, iteration: Iteration) => void;
    /** The current team */
    team: Team;
}

export interface IPlanningRowState {
    /** Is the context menu visible */
    contextMenuVisible: boolean;
}

/**
 * Renders an iteration in a work item drop zone
 */
export class PlanningRow extends React.Component<IPlanningRowProps, IPlanningRowState> {
    constructor(props: IPlanningRowProps, context: any) {
        super(props, context);
        this.state = {
            contextMenuVisible: false
        };
    }

    public render(): JSX.Element {
        const {
            isBacklogIteration,
            iteration,
            team
        } = this.props;
        
        const cardProps = { ...this.props };
        delete cardProps.onWorkItemsDropped;
        delete cardProps.isBacklogIteration;

        return (
            <SimpleDropZone
                droppableOptions={{
                    accept: this._accept,
                    classes: {
                        "ui-droppable-active": "sprint-planning-row--active",
                        "ui-droppable-hover": "sprint-planning-row--drag-hover"
                    },
                    drop: this._onDrop,
                    scope: DragDropScopes.ProductBacklog,
                    tolerance: "pointer"
                }}
                className="sprint-planning-row"

            >
                {isBacklogIteration ?
                    <BacklogIterationCard
                        iteration={iteration}
                        onClick={this.props.onBacklogClicked}
                        backlogUrl={this.props.backlogUrl}
                        team={team}
                    /> :
                    <IterationCard
                        {...cardProps}
                    />
                }
            </SimpleDropZone>
        );
    }

    private _accept = ($item: JQuery): boolean => {
        const {
            isBacklogIteration,
            getWorkItemDragInfo
        } = this.props;

        const {
            areAllItemsOwned,
            selectedWorkItemTypes
        } = getWorkItemDragInfo($item);

        const moveToIterationHelper = new MoveToIterationHelper();

        if (isBacklogIteration) {
            return moveToIterationHelper.canMoveToBacklog(selectedWorkItemTypes, areAllItemsOwned, BacklogConfigurationService.getBacklogConfiguration().requirementBacklog.name);
        }

        return moveToIterationHelper.canMoveToIteration(selectedWorkItemTypes, areAllItemsOwned);
    }

    private _onDrop = (event: JQueryEventObject, ui: JQueryUI.DroppableEventUIParam): void => {
        const {
            getWorkItemDragInfo,
            iteration,
            onWorkItemsDropped,
            isBacklogIteration,
            team,
        } = this.props;

        if (onWorkItemsDropped) {
            const $item = ui.draggable;
            const {
                selectedWorkItemIds
            } = getWorkItemDragInfo($item);

            if(isBacklogIteration) {
                onWorkItemsDropped(selectedWorkItemIds, iteration.iterationPath, format(BacklogContentViewResources.BacklogCardTitle, team.name), $item);
            } else {
                onWorkItemsDropped(selectedWorkItemIds, iteration.iterationPath, iteration.name, $item);
            }
            
        }
    }
}